import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from './../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantRoleEdit',
  props: {
    item: {
      type: Object,
      required: true
    },
    ruleList: {
      type: Array,
      required: true
    },
    tenantId: {
      type: Number,
      required: false,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      tagSearch: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    roleIsValid: function roleIsValid() {
      return (this.item.name || '').trim().length > 0 && (this.item.Rules || []).length > 0;
    },
    buttons: function buttons() {
      return [{
        icon: 'fas fa-save',
        action: 'saveRole',
        title: this.item.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.create'),
        tooltip: this.item.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.create'),
        valid: this.roleIsValid
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  }),
  methods: {
    close: function close() {
      this.$emit('close');
    },
    saveRole: function saveRole() {
      var _this = this;

      var newRole = cloneDeep(this.item);
      var selectedRules = newRole.Rules;
      delete newRole.Rules;
      newRole.rules = selectedRules;

      if (newRole.description === null) {
        delete newRole.description;
      }

      if (this.tenantId) {
        newRole.tenantId = this.tenantId;
      }

      var savePromise = undefined;

      if (!newRole.id) {
        savePromise = ApiService.createRole(newRole);
      } else {
        savePromise = ApiService.updateRole(newRole);
      }

      var context = this;
      savePromise.then(function () {
        // allow the role-cache to be cleared
        setTimeout(function () {
          context.$emit('roleSaved');
        }, 500);
      }).catch(function (error) {
        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack('Could not save role', 'error');
        }
      });
    }
  }
};